module.exports = __webpack_public_path__ + "static/menu-tab-bg-eb6282b22124bdaafd0027e3a4f87e6f.jpg";